var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.208C2 9.74218 2.36339 9.34723 2.85262 9.28135L4.24328 9.09408C6.04632 8.85129 7.88547 9.08058 9.55955 9.75687L11.196 10.418C11.3596 10.4841 11.4956 10.5873 11.5967 10.7133H12.4033C12.5044 10.5873 12.6404 10.4841 12.804 10.418L14.4405 9.75687C16.1145 9.08058 17.9537 8.85129 19.7567 9.09408L21.1474 9.28135C21.6366 9.34723 22 9.74218 22 10.208V14.6628C22 15.1204 21.649 15.511 21.1702 15.5862L19.3469 15.8726C18.2659 16.0425 17.1626 16.0425 16.0817 15.8726L14.0477 15.5531C13.6696 15.4937 13.3615 15.2344 13.2561 14.8869L12.4167 12.1174H11.5833L10.7439 14.8869C10.6385 15.2344 10.3304 15.4937 9.95227 15.5531L7.9183 15.8726C6.83736 16.0425 5.73406 16.0425 4.65313 15.8726L2.8298 15.5862C2.35096 15.511 2 15.1204 2 14.6628V10.208Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunglass);
export default __webpack_public_path__ + "static/media/sunglass.f786de148ce4546d25fb68ca844c1bbc.svg";
export { ForwardRef as ReactComponent };